import { createContext, ReactNode, useEffect, useState } from 'react'
import { Fade, Snackbar } from '@mui/material'

type SnackbarContextType = {
  showMessage: (message: string, duration?: number) => void
}

export const SnackbarContext = createContext<SnackbarContextType>({
  showMessage: () => {
    throw new Error('showMessage method not implemented')
  }
})

export const SnackbarProvider = ({ children }: { children: ReactNode }) => {
  const [queue, setQueue] = useState<{ message: string; duration: number }[]>(
    []
  )
  const [currentMessage, setCurrentMessage] = useState<{
    message: string
    duration: number
  } | null>(null)
  const [open, setOpen] = useState(false)

  const showMessage = (message: string, duration = 2000) => {
    setQueue(prevQueue => [...prevQueue, { message, duration }])
  }

  useEffect(() => {
    if (!open && queue.length > 0) {
      const nextMessage = queue[0]
      setCurrentMessage(nextMessage)
      setQueue(prevQueue => prevQueue.slice(1))
      setOpen(true)
      setTimeout(() => {
        setOpen(false)
      }, nextMessage.duration)
    }
  }, [open, queue])

  return (
    <SnackbarContext.Provider value={{ showMessage }}>
      {children}
      {currentMessage && (
        <Snackbar
          open={open}
          message={currentMessage.message}
          onClose={() => setOpen(false)}
          autoHideDuration={currentMessage.duration}
          TransitionComponent={Fade}
          ContentProps={{
            sx: {
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#333',
              color: '#fff',
              borderRadius: '8px',
              padding: '16px',
              width: 'auto'
            }
          }}
        />
      )}
    </SnackbarContext.Provider>
  )
}
